
export const PageDataState = {    
    Searchs: {
        province_id: {
            type: 'select',
            id: 'province_id',
            label: 'จังหวัด',
            value: '',
            placeholder: 'จังหวัด',
        },
        district_name: {
            type: 'text',
            id: 'district_name',
            label: 'อำเภอ',
            value: '',
            placeholder: 'อำเภอ',
        },
    },
    Inputs: {
        province_id: {
            type: 'select',
            id: 'province_id',
            label: 'จังหวัด',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 2,
                maxLength: 2
            },
            error: { status: null, msg: '' }
        },
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: true,
                minLength: 4,
                maxLength: 4
            },
            error: { status: null, msg: '' }
        },
        name: {
            type: 'text',
            id: 'name',
            label: 'อำเภอ',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 3,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        }
    },
    InputGroup: {}
}